/**
 * Combat game-feel for host events (combat/, run/): shakes, pad rumble
 * (strong, weak, ms) and blast sizes. Visual/haptic only — no balance here.
 */
export const FEEDBACK = {
  playerHit: { shake: 14, rumble: [0.7, 0.4, 180] },
  bossDeath: { shake: 28, rumble: [1, 0.8, 450] },
  /** Friendly explosions: blast scale = radius / blastPerRadius */
  aoe: { shake: 4, blastPerRadius: 50, numberLift: 20 },
  /** A minion dying (shot down or rammed into the ship) */
  minionBlast: 0.8,
} as const;
